import { computed, inject } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationSkipped,
  NavigationStart,
  Router,
} from '@angular/router';
import {
  signalStore,
  withState,
  withMethods,
  patchState,
  withHooks,
  withComputed,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, tap } from 'rxjs';

interface LoadingState {
  isRouteLoading: boolean;
  activeRequests: number;
}

const initalState: LoadingState = {
  isRouteLoading: false,
  activeRequests: 0,
};

export const LoadingStore = signalStore(
  { providedIn: 'root' },
  withState(initalState),
  withComputed(({ activeRequests }) => ({
    isPageLoading: computed(() => activeRequests() > 0),
  })),
  withMethods(store => ({
    startPageLoading() {
      patchState(store, { activeRequests: store.activeRequests() + 1 });
    },
    stopPageLoading() {
      patchState(store, {
        activeRequests: Math.max(0, store.activeRequests() - 1),
      });
    },
    _loaderOnNavigation: rxMethod<Event>(
      pipe(
        tap(event => {
          if (event instanceof NavigationStart) {
            patchState(store, { isRouteLoading: true });
          } else if (
            // Cancelled (e.g. guard redirect) and skipped (same URL) navigations end without NavigationEnd
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError ||
            event instanceof NavigationSkipped
          ) {
            patchState(store, { isRouteLoading: false });
          }
        })
      )
    ),
  })),
  withHooks((store, router = inject(Router)) => ({
    onInit() {
      store._loaderOnNavigation(router.events);
    },
  }))
);
